<span class="ico-alert-round wagering-block-dialog-alert-icon"></span>

<p class="wagering-block-dialog-coming-soon-notice">{{ 'geofencing.betsafe-ontario-coming-soon' | translate }}</p>

<img
	class="wagering-block-dialog-brand-logo"
	obgImageContent="geofencing.betsafe-ontario-logo"
	obgImageContentGroup="common"
/>
<p class="wagering-block-dialog-text">{{ 'geofencing.if-you-are-in-ontario' | translate }}</p>
<p class="wagering-block-dialog-download-text">{{ 'geofencing.ontario-restricted' | translate }}</p>
<p class="wagering-block-dialog-text">{{ 'geofencing.download-app' | translate }}</p>

<div class="download-link-container">
	<a *ngIf="!isIOS" class="android-download" [href]="androidAppUrl" target="_blank">
		<img obgImageContent="general.android-download" />
	</a>
	<a *ngIf="!isAndroid" class="ios-download" [href]="appStoreUrl" target="_blank">
		<img obgImageContent="general.app-store" />
	</a>
</div>
